import * as hoistNonReactStaticsModule from "../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js";

const hoistNonReactStatics =
  (hoistNonReactStaticsModule as { default?: unknown }).default ??
  hoistNonReactStaticsModule;

export default hoistNonReactStatics;
